import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { UploadDocuments } from '@ohif/ui';
import { apiUrl } from '../UploadDocument/apiUrl';
import { DicomMetadataStore } from '@ohif/core';
import SendLink from './button/SendLink';
import DownloadZip from './button/DowloadStudy';
import sendDicomAut from './utils/sendDicomAut';
import DicomSender from './button/DicomSend';
import ExportInstances from './utils/exportInstances';
import ExportImages from './utils/exportImages';
import DeleteDicom from './utils/deleteDicom';
const StudyListTableRow = ({ tableData, dataSource, active }) => {
  const { row, expandedContent, onClickRow, isExpanded, dataCY, clickableCY } = tableData;
  const [showOnlyButtons, setShowOnlyButtons] = useState(false);
  const [fileCheck, setFileCheck] = useState(false);
  const [studyMetadata, setStudyMetadata] = useState(null);
  const [vistaUsuario, setVistaUsuario] = useState('');
  const [rolUsuario, setRolUsuario] = useState('');
  const [institutionName, setInstitutionName] = useState('S/I');
  const [studyDescription, setStudyDescription] = useState('S/D');
  const [studyProtocolName, setStudyProtocolName] = useState('S/P');
  const [loadingMetaData, setLoadingMetaData] = useState(true);
  const [isVisible, setIsVisible] = useState(false);
  const rowRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    if (rowRef.current) {
      observer.observe(rowRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, []);


  useEffect(() => {
    const localStr = localStorage.getItem('usuario');
    const session = localStr ? JSON.parse(localStr) : null;
    const tiposVista = session ? session.user.vistas : [];
    const tiposRol = session ? session.user.role : '';
    setRolUsuario(tiposRol);
    setVistaUsuario(tiposVista);
  }, []);

  const studyInstanceUid = clickableCY;
  const seriesColumn = {
    description: 'Descripcion',
    seriesNumber: 'Series',
    modality: '',
    instances: 'Imagenes',
  };
  const normalizePatientName = rawName => {
    if (!rawName) {
      return '';
    }

    return rawName.replace(/[\^,]/g, ' ').replace(/\s+/g, ' ').trim();
  };
  const seriesStudy = row.find((r: any) => r.key === 'seriesStudy')?.content;
  const studyId = row.find((r: any) => r.key === 'instanceUid')?.content;
  const handleUploadClick = (e: React.MouseEvent) => {
    e.stopPropagation(); // Esto evitará que el clic en UploadDocuments active el Link
  };
  const patient = row.find((r: any) => r.key === 'patientName')?.content;
  let instanceData: any

  useEffect(() => {
    if (!isVisible) return;
    const loadStudyMetadata = async () => {
      // Verificar si ya está cargado
      let study = DicomMetadataStore.getStudy(studyInstanceUid);

      if (!study) {
        // Precargar metadata completa
        await dataSource.retrieve.series.metadata({
          StudyInstanceUID: studyInstanceUid,
          madeInClient: true,
        });

        study = DicomMetadataStore.getStudy(studyInstanceUid);
      }

      if (study && study.series && study.series[0] && study.series[0].instances && study.series[0].instances[0]) {
        const instanceMeta = study.series[0].instances[0];
        instanceData = {
          StudyDate: instanceMeta.StudyDate || '', // FECHA DEL ESTUDIO
          StudyDescription: instanceMeta.StudyDescription || '', // NOMBRE DE LA INSTITUCION
          InstitutionName: instanceMeta.InstitutionName || '', // NOMBRE DE LA INSTITUCION
          ReferringPhysicianName: instanceMeta.ReferringPhysicianName || '', // NOMBRE DEL MEDICO QUE REFIERE
          StationName: instanceMeta.StationName || '', // NOMBRE DE LA ESTACION
          PerformingPhysicianName: instanceMeta.PerformingPhysicianName || '', // NOMBRE DEL MEDICO QUE REALIZA EL ESTUDIO
          NameOfPhysiciansReadingStudy: instanceMeta.NameOfPhysiciansReadingStudy || '', // NOMBRE DEL MEDICO QUE LEE EL ESTUDIO
          OperatorsName: instanceMeta.OperatorsName || '', // NOMBRE DEL OPERADOR
          ManufacturerModelName: instanceMeta.ManufacturerModelName || '', // MODELO DEL MANUFACTURADOR
          PatientName: instanceMeta.PatientName ? instanceMeta.PatientName[0].Alphabetic : null, // NOMBRE DEL PACIENTE
          ProtocolName: instanceMeta.ProtocolName || '', // NOMBRE DEL PROTOCOLO
        };

        setStudyDescription(instanceData.StudyDescription);
        setInstitutionName(instanceData.InstitutionName);
        setStudyProtocolName(instanceData.ProtocolName);
      }

      setStudyMetadata(study);
      setLoadingMetaData(false);
    };
    const fetchData = async () => {
      await loadStudyMetadata();
      await sendDicomAut(studyInstanceUid);
    };
    fetchData();
  }, [studyInstanceUid, dataSource, isVisible]);

  useEffect(() => {
    if (!isVisible) return;
    const verificarArchivo = async () => {
      const normalizePatientName = rawName => {
        if (!rawName) {
          return '';
        }

        return rawName.replace(/[\^,]/g, ' ').replace(/\s+/g, ' ').trim();
      };
      try {
        const response = await fetch(
          `${apiUrl}/api/subida/upload/${normalizePatientName(patient)}`
        );
        if (response.status === 200) {
          setFileCheck(true);
        }
      } catch (error) {
        setFileCheck(false);
      }
    };
    verificarArchivo();
  }, [patient, isVisible]);
  return (
    <>
      <div
        ref={rowRef}
        data-cy={dataCY}
        className="flex items-center"
      >
        {showOnlyButtons ? (
          <div className="flex-1">
            <div
              className={classnames(
                'group my-2 mx-1 cursor-pointer rounded-xl border shadow-sm transition-all duration-300',
                'bg-plom-main',
                isExpanded
                  ? 'border-plom-active shadow-md ring-1 ring-white'
                  : 'border-plom-dark hover:border-plom-main'
              )}
              onClick={onClickRow}
              data-cy={clickableCY}
            >
              <div className="w-full items-center gap-4 p-2">
                <div className="grid grid-cols-4 justify-items-center gap-2">
                  {(vistaUsuario.includes('LINK DE ENVIO') || rolUsuario === 'admin') && (
                    <div className="hover:bg-plom-dark flex w-full flex-col items-center justify-center rounded-md hover:shadow-md">
                      <SendLink instanceUid={studyId} />
                      <span className="text-xs">Compartir</span>
                    </div>
                  )}

                  {(vistaUsuario.includes('DOC') || rolUsuario === 'admin') && (
                    <div className="hover:bg-plom-dark xs:p-4 flex w-full flex-col items-center justify-center rounded-md hover:shadow-md">
                      <UploadDocuments
                        value={String(row.find((r: any) => r.key === 'patientName')?.content)}
                        seriesStudy={seriesStudy}
                        seriesColumn={seriesColumn}
                        instanceUid={studyId}
                      />
                      <span className="text-xs">Documentos</span>
                    </div>
                  )}

                  {(vistaUsuario.includes('DESCARGA DE SERIES') || rolUsuario === 'admin') && (
                    <div className="hover:bg-plom-dark xs:p-4 flex w-full flex-col items-center justify-center rounded-md hover:shadow-md">
                      <ExportImages seriesNumberCont={studyId} />
                      <span className="text-xs">Descarga</span>
                    </div>
                  )}

                  {(vistaUsuario.includes('SEND DICOM') || rolUsuario === 'admin') && (
                    <div className="hover:bg-plom-dark xs:p-4 flex w-full flex-col items-center justify-center rounded-md hover:shadow-md">
                      <ExportInstances studyMetadata={String(studyId) || ''}></ExportInstances>
                      <span className="text-xs">Enviar</span>
                    </div>
                  )}
                </div>

                {rolUsuario === 'admin' && (
                  <div className="hidden xs:p-2 flex w-full flex-col items-center justify-center rounded-md text-red-400 hover:bg-red-600 hover:text-white hover:shadow-md">
                    {/* <DicomSender studyMetadata={String(studyId) || ''} /> */}
                    <DeleteDicom seriesNumberCont={String(studyId) || ''}></DeleteDicom>
                  </div>
                )}
              </div>
            </div>
          </div>
        ) : (
          <a
            href={`/viewer?StudyInstanceUIDs=${studyId}`}
            className="flex-1"
          >
            <div
              className={classnames(
                'group my-2 mx-1 flex cursor-pointer items-stretch rounded-xl border shadow-sm transition-all duration-300',
                'bg-plom-main hover:bg-plom-main/5 hover:shadow-md',
                isExpanded
                  ? 'border-plom-active shadow-md ring-1 ring-white'
                  : 'border-plom-dark hover:border-plom-main'
              )}
              onClick={onClickRow}
              data-cy={clickableCY}
            >
              <span
                className={`${fileCheck ? 'bg-yellow-400' : 'bg-red-700'} w-3 rounded-l-xl`}
              ></span>
              <div className="xs:p-4 p-2">
                <div className="flex items-center justify-between sm:gap-4">
                  <div className="flex justify-between gap-4 rounded-lg bg-slate-800">
                    {/* Icono */}
                    <div className="max-sm:hidden flex flex-shrink-0 items-center justify-center rounded-full bg-slate-700 text-white">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        className="bi bi-person-circle w-6 h-6 xs:w-9 xs:h-9"
                        viewBox="0 0 16 16"
                      >
                        <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0" />
                        <path
                          fillRule="evenodd"
                          d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1"
                        />
                      </svg>
                    </div>

                    {/* Info principal */}
                    <div className="flex flex-col gap-1 text-white">
                      <h3 className="texs-xs max-sm:text-sm font-semibold">
                        <span className="font-bold">Paciente:</span>{' '}
                        {row.find((r: any) => r.key === 'patientName')?.content}
                      </h3>

                      <p className="texs-xs max-sm:text-sm hidden max-sm:block">
                        <span className="font-semibold">Institucion:</span>{' '}
                        {loadingMetaData ? <span className="animate-pulse">...</span> : institutionName}
                      </p>
                      <p className="texs-xs max-sm:text-sm  text-white">
                        <span className="font-semibold">Modalidad: </span>
                        <span
                          className={classnames(
                            'inline-flex items-center rounded-full text-xs font-medium sm:border sm:px-2.5 sm:py-0.5'
                          )}
                        >
                          {row.find((r: any) => r.key === 'modality')?.content}
                        </span>
                      </p>

                      <p className="texs-xs max-sm:text-sm">
                        <span className="font-semibold">Fecha:</span>{' '}
                        {row.find((r: any) => r.key === 'studyDate')?.content}
                      </p>
                    </div>

                    {/* Institución, Description */}
                    <div className="ml-auto texs-xs max-sm:text-sm max-sm:hidden">
                      <p className="font-semibold text-slate-300">
                        Institución:    {loadingMetaData ? <span className="inline-block w-20 h-3 bg-slate-500 rounded animate-pulse ml-2"></span> : institutionName}
                      </p>
                      <p className="font-semibold text-slate-300 flex items-center">
                        {loadingMetaData ? (
                          <span className="inline-block w-32 h-3 bg-slate-500 rounded animate-pulse mt-1"></span>
                        ) : (
                          <>
                            {studyProtocolName ? 'Protocolo' : 'Descripción'}:    {normalizePatientName(studyDescription ? studyDescription : studyProtocolName ? studyProtocolName : 'S/D')}
                          </>
                        )}
                      </p>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </a>
        )}

        <div className="flex gap-x-0">
          <div
            className={classnames(
              'xs:p-3 group my-2 max-xs:py-5 cursor-pointer rounded-xl border p-1 shadow-sm transition-all duration-300',
              'bg-plom-main hover:bg-plom-main/5 border-plom-dark hover:border-plom-main hover:shadow-md'
            )}
            onClick={handleUploadClick} // Prevenir redirección
          >
            <div className="py-2">
              <div className="flex items-center justify-between sm:gap-4">
                <div className="flex h-10 w-10 items-center justify-center rounded-full">
                  <button onClick={() => setShowOnlyButtons(!showOnlyButtons)}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="30"
                      height="30"
                      fill="currentColor"
                      className="bi bi-sliders"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fillRule="evenodd"
                        d="M11.5 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M9.05 3a2.5 2.5 0 0 1 4.9 0H16v1h-2.05a2.5 2.5 0 0 1-4.9 0H0V3zM4.5 7a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M2.05 8a2.5 2.5 0 0 1 4.9 0H16v1H6.95a2.5 2.5 0 0 1-4.9 0H0V8zm9.45 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m-2.45 1a2.5 2.5 0 0 1 4.9 0H16v1h-2.05a2.5 2.5 0 0 1-4.9 0H0v-1z"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

StudyListTableRow.propTypes = {
  tableData: PropTypes.shape({
    /** A table row represented by an array of "cell" objects */
    row: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string.isRequired,
        /** Optional content to render in row's cell */
        content: PropTypes.any,
        /** Title attribute to use for provided content */
        title: PropTypes.string,
        gridCol: PropTypes.number.isRequired,
      })
    ).isRequired,
    expandedContent: PropTypes.node,
    onClickRow: PropTypes.func,
    isExpanded: PropTypes.bool,
    dataCY: PropTypes.string,
    clickableCY: PropTypes.string,
  }),
  dataSource: PropTypes.object,
};

export default StudyListTableRow;
